export const ERROR_API = 'errorAPI';
export const ERROR_SAVE_REGION = 'errorSaveRegion';
export const ERROR_GIFTCARD = 'errorGiftCart';
export const ERROR_LOGIN = 'errorLogin';
export const ERROR_WRONG_PRODUCT_CODE = 'errorWrongProductCode';
export const ERROR_ART_CANNOT_LOAD = 'errorArtCannotLoad';
export const ERROR_PET_NOT_DETECTED = 'errorPetNotDetected';
export const ERROR_PET_SYSTEM_ERROR = 'errorPetSystemError';
